import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import translate from '../../other/translate.json';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';

const CustomRadio = withStyles({
  root: {
    color: '#F6F6FB',
    '&$checked': {
      color: '#EB505E',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function FilterShowApplicatonsRadiio(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';
  const { isArchive, hasVideo, isCFTBank } = props
  const renderFilters = () => {
    if (isCFTBank) {
      return (
        <FormControl component="fieldset">
          <FormLabel component="legend" focused={false} className={classes.header}>{translate.Words[`ShowApplications${language}`]}:</FormLabel>

          <RadioGroup aria-label="g" name="g1" value={props.value} onChange={props.handleChange}>
            <FormControlLabel className={classes.label} value={1} control={<CustomRadio />} label={translate.Words[`All${language}`]} />
            <FormControlLabel className={classes.label} value={2} control={<CustomRadio />} label={translate.Words[`MultiThreaded${language}`]} />
            <FormControlLabel className={classes.label} value={3} control={<CustomRadio />} label={translate.Words[`NotMultiThreaded${language}`]} />
          </RadioGroup>
        </FormControl>
      )
    } else if (!isArchive || hasVideo) {
      return (
        <FormControl component="fieldset">
          <FormLabel component="legend" focused={false} className={classes.header}>{translate.Words[`ShowApplications${language}`]}:</FormLabel>
        </FormControl>
      )
    }
  }

  return (
    <React.Fragment>
      {renderFilters()}
    </React.Fragment >
  )
}

const useStyles = makeStyles(theme => ({
  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  label: {
    color: '#8987A2'
  }
}))